var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.StartupEditField,{attrs:{"field-name":"numEmployeesMin","label":"Employees","options":_setup.employeesCountOptions},model:{value:(_setup.employees),callback:function ($$v) {_setup.employees=$$v},expression:"employees"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }